import { results } from '../data/results';

    export const getResultType = (scoreA) => {
    if (scoreA >= 44) return results.type1;
    if (scoreA >= 38) return results.type3; // 3번이 충전형
    if (scoreA >= 31) return results.type2; // 2번이 올인형
    if (scoreA >= 25) return results.type4;
    if (scoreA >= 19) return results.type7; // 7번이 공간음미형
    if (scoreA >= 13) return results.type5; // 5번이 리셋형
    if (scoreA >= 7)  return results.type6; // 6번이 고요형
    return results.type8; 
    };

// 결과 유형을 점수에 따라 반환하는 함수입니다. 점수 범위에 따라 각 유형을 매핑하여 결과를 제공합니다.